<template lang="pug">
SingaContextMenu(@toggle="toggle")
	template(v-slot:trigger)
		SingaButton.is-regular.is-transparent-dark.share-button(:class="{'list-button': externalUrl}" icon-left="share-social-outline")
	template(v-slot:content)
		CommonShareButtons(:externalUrl="externalUrl" :playlistData="playlistData")
</template>

<script lang="ts" setup>
defineProps({
	externalUrl: {
		type: String,
		default: () => null,
		required: false
	},
	playlistData: {
		type: Object,
		default: () => null
	}
})

const isOpen = ref(false)

const toggle = (toggleState: boolean) => {
	isOpen.value = toggleState
}
</script>

<style lang="sass" scoped>
.list-button
	height: 40px

.share-button
	width: 61px
</style>
